import {Component, ElementRef, ViewChild} from '@angular/core';
import {MatDatepicker} from '@angular/material/datepicker';
import {Moment} from 'moment';
import {DeviceDetectorService} from 'ngx-device-detector';
import {MatInput} from '@angular/material/input';
import {ControlValueAccessorComponent} from './control-value-accessor.component';

@Component({
  template: ''
})
export abstract class ResponsiveDatepickerComponent extends ControlValueAccessorComponent {

  @ViewChild(MatInput, {static: false, read: ElementRef})
  public dateInput: ElementRef;

  @ViewChild(MatDatepicker, {static: false})
  public datePicker: MatDatepicker<Moment>;

  public isRunningOnMobile: boolean;
  public placeholderText: string;
  public datePickerOpen = false;

  constructor(private deviceDetectorService: DeviceDetectorService) {
    super();
    this.isRunningOnMobile = !this.deviceDetectorService.isDesktop();
    this.placeholderText = this.isRunningOnMobile ? null : this.placeholderTextForInput();
  }

  public onInputClick() {
    if (this.isRunningOnMobile) {
      this.openDatepicker();
    }
  }

  public openDatepicker() {
    this.datePickerOpen = true;
    this.datePicker.open();
  }

  public closeDatepicker() {
    this.datePickerOpen = false;
    this.datePicker.close();
  }

  protected abstract placeholderTextForInput();

}
